export const ROUTE_ARTICLES = "/articles/*"